import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export interface onboardingDocumentsState {
  onboardingDocumentsUrl: string;
}
export interface onboardingDocumentsAction {
  setOnboardingDocumentsUrl: (url: string) => void;
  reset: () => void;
}

export const useOnboardingDocumentsLinkStore = create<
  onboardingDocumentsState & onboardingDocumentsAction
>()(
  devtools(
    persist(
      (set) => ({
        onboardingDocumentsUrl: "",
        setOnboardingDocumentsUrl: (onboardingDocumentsUrl) =>
          set({ onboardingDocumentsUrl }),
        reset: () => set({ onboardingDocumentsUrl: "" }),
      }),
      {
        name: "onboarding-documents-url-storage",
        storage: createJSONStorage(() => sessionStorage),
      }
    )
  )
);
